export default {"src":"/_next/static/media/pharmacy-info.70f60425.svg","height":441,"width":466,"blurWidth":0,"blurHeight":0};